import { v4 as uuidv4 } from "uuid";

import { formatTimestamp } from "utils/format";

// 目前這裡所有關於 Hierarchy 都只處理到 standalone 的情況
// 未來再增加 nonStandalone 的情況

// 規則: 如果是 standalone org 會放在 realm 下 (依照之前設計的方式) org 就會是空陣列

// 取最新的 msp table 資料
export const fetchMspListData = (mspUuid, ws, token) => {
  const requestMsp = {
    jsonrpc: "2.0",
    id: mspUuid,
    method: "read",
    params: {
      resource: "/me/memberships",
      accessToken: token,
    },
  };
  ws.send(JSON.stringify(requestMsp));
}

export const handleMspListMessage = (mspUuid, msg, theLatestPermissionData) => {
  const { id, result } = msg
  if (id !== mspUuid) return;
  let tmpEntData = { data: [] }
  let tmpAloneOrgData = { data: [] }

  if (result.data.enterprises && result.data.enterprises.length > 0) {
    tmpEntData.data = result.data.enterprises
  }
  if (result.data.standaloneOrgs && result.data.standaloneOrgs.length > 0) {
    tmpAloneOrgData.data = result.data.standaloneOrgs
  }

  const data = mergeRealmData(tmpEntData, tmpAloneOrgData)
  theLatestPermissionData.realm = data
}

// format 拿到的 realm 的資料轉成前端會用到格式
export const mergeRealmData = (entList, aloneOrgList) => {
  let resultAry = []

  let enterprisesList = []
  if (entList.data && entList.data.length > 0) {
    enterprisesList = entList.data
  }
  let standAloneList = []
  if (aloneOrgList.data && aloneOrgList.data.length > 0) {
    standAloneList = aloneOrgList.data
  }

  for (let childEnt of enterprisesList) {
    let child = {
      id: childEnt.entId,
      name: childEnt.entName,
      hasManageOrg: true,
      roleId: childEnt.entRoleId,
      roleName: childEnt.entRoleName,
      createdAt: childEnt.createdAt,
      createdTime: formatTimestamp(childEnt.createdAt, "-"),
      enableAction: (childEnt.entRoleId === 1 || childEnt.entRoleId === 2) ? true : false
    }
    resultAry.push(child)
  }
  for (let childAloneOrg of standAloneList) {
    let child = {
      id: childAloneOrg.orgId,
      name: childAloneOrg.orgName,
      hasManageOrg: false,
      roleId: childAloneOrg.orgRoleId,
      roleName: childAloneOrg.orgRoleName,
      createdAt: childAloneOrg.createdAt,
      createdTime: formatTimestamp(childAloneOrg.createdAt, "-"),
      enableAction: (childAloneOrg.orgRoleId === 5 || childAloneOrg.orgRoleId === 6) ? true : false
    }
    resultAry.push(child)
  }

  return resultAry;
}

// 取最新的 org table 資料 (如果是從 Hierarchy 角度看因為 org 下會顯示 site table)
// 所以實際上是取 site taable
export const fetchOrgListData = (orgUuid, ws, token, currentPermissionData) => {
  if (!currentPermissionData.mspId) {
    const requestOrg = {
      jsonrpc: "2.0",
      id: orgUuid,
      method: "read",
      params: {
        resource: `/orgs/${currentPermissionData.orgId}/sites`,
        accessToken: token,
      },
    };
    ws.send(JSON.stringify(requestOrg));
  } else {
    const requestOrg = {
      jsonrpc: "2.0",
      id: orgUuid,
      method: "read",
      params: {
        resource: `/ents/${currentPermissionData.mspId}/orgs/${currentPermissionData.orgId}/sites`,
        accessToken: token,
      },
    };
    ws.send(JSON.stringify(requestOrg));
  }
}

export const handleOrgListMessage = (orgUuid, msg, theLatestPermissionData) => {
  const { id, result } = msg
  if (id !== orgUuid) return;
  const data = mergeOrgData(result)
  theLatestPermissionData.site = data
}

// format 拿到的 org 的資料轉成前端會用到格式
export const mergeOrgData = (siteList) => {
  let resultAry = []
  let orgSiteList = []
  if (siteList.data && siteList.data.sites.length > 0) {
    orgSiteList = siteList.data.sites
  }

  for (let childEnt of orgSiteList) {
    let child = {
      id: childEnt.siteId,
      name: childEnt.siteName,
      roleId: childEnt.siteRoleId,
      roleName: childEnt.siteRoleName,
    }
    resultAry.push(child)
  }

  return resultAry;
}

// 可以取得最新的權限資料
export const getTheLatestSelectBreadcrumbsData = (currentPermissionData, theLatestPermissionData) => {
  const { mspId, orgId, siteId } = currentPermissionData;
  const { realm = [], orgs = [], site = [] } = theLatestPermissionData;

  const hasMsp = Boolean(mspId);

  const result = {
    realm: {},
    orgs: {},
    site: {},
  };

  if (hasMsp) {
    // mspId 有值
    result.realm = realm.find(item => item.id === mspId) || {};
    result.orgs = orgs.find(item => item.id === orgId) || {};
    result.site = site.find(item => item.id === siteId) || {};
  } else {
    // mspId 沒有值 (standalone)
    result.realm = realm.find(item => item.id === orgId) || {};
    result.site = site.find(item => item.id === siteId) || {};
  }

  return result;
}

// 驗證目前的網站的 麵包屑/傳進來的資料 是否跟最新的權限一樣
// false 權限不一致
// true 權限一樣
export const validatePermissions = (currentPermissionData, theLatestPermissionData) => {
  const result = { realm: null, orgs: null, site: null };

  const compareRealm = () => {
    const source = currentPermissionData.realm || [
      {
        id: Object.prototype.hasOwnProperty.call(currentPermissionData, "entRoleName") ? currentPermissionData.entId : currentPermissionData.orgId,
        name: Object.prototype.hasOwnProperty.call(currentPermissionData, "entRoleName") ? currentPermissionData.entName : currentPermissionData.orgName,
        roleName: Object.prototype.hasOwnProperty.call(currentPermissionData, "entRoleName") ? currentPermissionData.entRoleName : currentPermissionData.orgRoleName
      }
    ];

    if (!source || !theLatestPermissionData.realm) return null;

    for (let item of theLatestPermissionData.realm) {
      const match = source.find(r => r.id === item.id || r.name === item.name);
      if (match && (match.roleName !== item.roleName)) {
        return false;
      }
    }

    return true;
  };

  // 目前只做 Standalone 所以先用 null
  const compareOrgs = () => null;

  const compareSite = () => {
    if (!currentPermissionData.siteId) return null;

    const source = currentPermissionData.site || [
      {
        id: currentPermissionData.siteId,
        name: currentPermissionData.siteName,
        roleName: currentPermissionData.siteRoleName
      }
    ];

    for (let item of theLatestPermissionData.site) {
      const match = source.find(s => s.id === item.id);
      if (match && (match.roleName !== item.roleName)) {
        return false;
      }
    }

    return true;
  };

  result.realm = compareRealm();
  result.orgs = compareOrgs();
  result.site = compareSite();

  return result;
}

// theLatestPermissionData: 拿到所有 realm org site 全部資料的列表
// theLatestSelectBreadcrumbs: 拿到最新的權限的資料
// validatePermission: 驗證目前網站的權限跟最新的權限資料
// 傳入的 validatePermissionData 為 api 來的資料 如果不傳會使用目前的 local storge 的資料
export const getPermissionCheckData = async ({ ws, token, validatePermissionData }) => {
  const mspUuid = uuidv4();
  const orgUuid = uuidv4();

  const theLatestPermissionData = { realm: [], orgs: [], site: [] };

  const currentSelectBreadcrumbs = JSON.parse(localStorage.getItem('selectBreadcrumbs') || '{}');
  const standalone = !currentSelectBreadcrumbs.orgs?.id || Object.keys(currentSelectBreadcrumbs.orgs || {}).length === 0;

  const currentPermissionsConfig = {
    standalone: {
      orgId: currentSelectBreadcrumbs.realm?.id,
      orgName: currentSelectBreadcrumbs.realm?.name,
      orgRoleName: currentSelectBreadcrumbs.realm?.roleName,
      siteId: currentSelectBreadcrumbs.site?.id,
      siteName: currentSelectBreadcrumbs.site?.name,
      siteRoleName: currentSelectBreadcrumbs.site?.roleName,
    },
    nonStandalone: {
      entId: currentSelectBreadcrumbs.realm?.id,
      entName: currentSelectBreadcrumbs.realm?.name,
      entRoleName: currentSelectBreadcrumbs.realm?.roleName,
      orgId: currentSelectBreadcrumbs.orgs?.id,
      orgName: currentSelectBreadcrumbs.orgs?.name,
      orgRoleName: currentSelectBreadcrumbs.orgs?.roleName,
      siteId: currentSelectBreadcrumbs.site?.id,
      siteName: currentSelectBreadcrumbs.site?.name,
      siteRoleName: currentSelectBreadcrumbs.site?.roleName,
    },
  };

  const mode = standalone ? 'standalone' : 'nonStandalone';
  const currentPermissionData = validatePermissionData || currentPermissionsConfig[mode];

  const fetchData = (uuid, sendFn, handleFn) =>
    new Promise(resolve => {
      const handler = event => {
        const data = JSON.parse(event.data);
        if (data.id !== uuid) return;

        handleFn(uuid, data, theLatestPermissionData);
        ws.removeEventListener('message', handler);
        resolve();
      };

      ws.addEventListener('message', handler);
      sendFn(uuid, ws, token, currentPermissionData);
    });

  await fetchData(mspUuid, fetchMspListData, handleMspListMessage);
  await fetchData(orgUuid, fetchOrgListData, handleOrgListMessage);

  const theLatestSelectBreadcrumbs = getTheLatestSelectBreadcrumbsData(currentPermissionData, theLatestPermissionData);

  const validatePermission = validatePermissions(currentPermissionData, theLatestPermissionData);

  return { theLatestPermissionData, theLatestSelectBreadcrumbs, validatePermission };
};
